import { Navigate } from "react-router-dom";
import { useAuthContext } from "../hooks/useAuthContext";

const PrivateRoute = ({ children }) => {
  const { user } = useAuthContext();

  // If the user is not logged in, redirect to login page
  if (!user) return <Navigate to="/login" replace />;

  // If user exists, allow access to the protected route
  return children;
};

export default PrivateRoute;
